import React from "react";

import './Center.css';

const Center = ({ children }) => {
    return (
        <div className="center">
            {children}
        </div>
    )
}

export default Center;